import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const useStyles = makeStyles(() => ({
  svgGreen: {
    transform: "rotate(270deg)",
    '& path': {
      stroke: '#07C806',
    }
  },
}));

export const TotalNumberContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 16px;
  width: 100%;
`;

export const NumberContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardTitle = styled.span`
  color: #707070;
  white-space: nowrap;
`;

export const StatusIndicatorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ArrowGreenUpContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background: rgba(7, 200, 6, 0.16);
  border-radius: 48px;
`;

export const PercentageText = styled.span`
  font-size: 18px;
  color: #07C806;
  white-space: nowrap;
`;
